import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/close_btn.png'


const _hoisted_1 = { class: "contrainer" }
const _hoisted_2 = { style: {"width":"40%","height":"50px","background":"#fff","z-index":"1","text-align":"center","line-height":"50px","font-size":"40px","font-weight":"800","position":"relative"} }
const _hoisted_3 = {
  key: 0,
  style: {"width":"40%","height":"40px","gap":"10px","background-color":"#fff","z-index":"1","display":"flex"}
}
const _hoisted_4 = {
  key: 1,
  style: {"height":"70px","width":"40%","background":"#fff","display":"flex","align-items":"center","justify-content":"center","z-index":"1","position":"relative"}
}
const _hoisted_5 = { style: {"margin-left":"20px","position":"absolute","left":"0"} }
const _hoisted_6 = ["src"]

import { onMounted, onUnmounted, ref, nextTick } from 'vue'
import announceAPI from '@/api/announceAPI'
import userApi from '@/api/userAPI'
import {Signature, Contract} from "@/common/types";
import PasswordPop from '@/components/popup/PasswordPop.vue'

import VuePdfApp from 'vue3-pdf-app'
import 'vue3-pdf-app/dist/icons/main.css'

import { PDFDocument, PDFImage } from 'pdf-lib'
import { calculateImageSize, convertBlobToPng, mmToPx } from '@/common/util';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContractPop',
  props: {
    data: {},
    type: {},
    seq: {},
    seq2: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit

const htmlContentList: any = ref([])
onMounted(() => {
  localStorage.removeItem('pdfjs.history')
  ImageList = []
  selectedImg.value = ''
  sealList = {
    사용인감: '',
    원본대조필: '',
    인감: ''
  }
  if(props.type != 'I') {
    modifyPdf()
  }
})
const openSrc = (e:any) => {
  console.log(e)
}
onUnmounted(() => {
  pdfSrc.value = ''
  htmlContentList.value = []
  renderFlag.value = true
})
const allReadChk = ref(false)
const passwordFlag = ref(false)
const allpageseal = ref(false)
const pdfSrc = ref('')
const newSrc = ref<HTMLInputElement>()
const oriPdfSrc = ref('')
const imgFile: any = ref('')
const renderFlag = ref(true)
const pdfContainer = ref()
const pdfApp = ref()
let offsetScale = 1
const img = ref('')
const selectedImg = ref('')
const imgStyle = ref({ width: 50, height: 50 })
let currentPage = 1
const sealChecked = ref(false)

const confirm = async() => {
  if(!allReadChk.value) {
    alert('계약서를 모두 읽어주세요.')
    return
  }
  if(ImageList.length == 0 && !sealChecked.value) {
    alert('날인을 해주세요. 날인된 계약서라면 날인완료를 체크해주세요.')
    return
  }
  const existingPdf = await fetch(pdfSrc.value).then((res) => res.arrayBuffer())
  const pdfDoc = await PDFDocument.load(existingPdf);
  const pdfBytes = await pdfDoc.save();
  const pdfFile = new File([pdfBytes], props.data.저장파일.원파일명, { type: 'application/pdf' });
  announceAPI
    .contractSign(props.seq, props.data.계약서순번, props.seq2, pdfFile)
    .then((res: any) => {
      alert('계약서 작성이 완료되었습니다.');
      window.location.reload();
    })
    .catch((err: any) => {
      console.log(err);
    });
}
const modifyPdf = async () => {
  
  let pageWidth = 0
  let pageHeight = 0
  let response:any
    if (props.seq) {
      response = await announceAPI.contractFile(props.seq, props.seq2);
    }
    const pdfList = response.data;
    let blobs:any = []
    pdfList.forEach((base64Pdf: string, index: number) => {
      const byteCharacters = atob(base64Pdf);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      blobs.push(new Blob([byteArray], { type: 'image/png' }))
    });
    const pdfDoc = await PDFDocument.create()

    pdfDoc.setProducer('ptbid')
    for (let i = 0; i < blobs.length; i++) {
      const page = pdfDoc.addPage()
      const imageBytes = await blobs[i].arrayBuffer();

      const pngImage = await pdfDoc.embedPng(imageBytes)
      const { width: w, height: h } = page.getSize()
      const scaled = pngImage.scaleToFit(w, h)
      page.drawImage(pngImage, {
        x: 0,
        y: 0,
        width: scaled.width,
        height: scaled.height
      })
      if (pageWidth == 0 && pageHeight == 0) {
        pageWidth = scaled.width
        pageHeight = scaled.height
      }
    }

    const pdfBytes = await pdfDoc.save()
    const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' })
    pdfSrc.value = await URL.createObjectURL(pdfBlob) // Vue 상태에 PDF 소스를 설정
    oriPdfSrc.value = await URL.createObjectURL(pdfBlob)
    await nextTick()
    // PDF 렌더링 플래그 설정
    renderFlag.value = false

    const div: any = document.querySelector('.contrainer')
    div.addEventListener('mousemove', moveEvent)

    const pageElement:any = await waitForTextLayer()
    offsetScale = pageWidth / pageElement[0].offsetWidth

    pdfSrc.value = await URL.createObjectURL(pdfBlob) // Vue 상태에 PDF 소스를 설정
    oriPdfSrc.value = await URL.createObjectURL(pdfBlob)

    document.getElementById('viewerContainer')!.addEventListener('scroll', () => {
      if(pdfApp.value) {
        pdfApp.value.zoomReset()
      }
      const historyData = JSON.parse(window.localStorage.getItem("pdfjs.history") || "{}");
      currentPage = Math.max((historyData.files[0].page || 1),currentPage);
      if(currentPage == pdfDoc.getPageCount()) {
        document.getElementsByClassName("contract_btn")[0].classList.add('active')
        allReadChk.value = true
      } else {
        document.getElementsByClassName("contract_btn")[0].classList.remove('active')
      }
    })
}
const afterCreatedHandler = async (e: any) => {
  pdfApp.value = e
}
const pagesRenderedHandler = async (e: any) => {
  console.log(e,offsetScale)
}
const moveEvent = (e: any) => {
  if (selectedImg.value == '') return
  const div: any = document.querySelector('.contrainer')
  const cursor: any = document.querySelector('.cursor')
  const textElement = e.target!.closest('.textLayer')
  if (!textElement) {
    cursor.classList.add('disabled')
    return
  } else {
    cursor.classList.remove('disabled')
    const boundingRect = div.getBoundingClientRect()
    const x = e.clientX - boundingRect.left
    const y = e.clientY - boundingRect.top
    cursor.style.left = `${x - imgStyle.value.width / 2}px`
    cursor.style.top = `${y - imgStyle.value.height / 2}px`
  }
}
const waitForTextLayer = () => {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      const pageElement = document.getElementsByClassName('textLayer')
      if (pageElement.length > 0) {
        clearInterval(interval)
        resolve(pageElement)
      }
    }, 100)
  })
}
let sealList: any = {
  사용인감: '',
  원본대조필: '',
  인감: ''
}
const ImgChange = async (type: string) => {
  if (selectedImg.value == type) {
    selectedImg.value = ''
    return
  }
  selectedImg.value = type
  switch (type) {
    case '사용인감':
      {
        if (sealList.사용인감 == '') {
          userApi
            .sealFile(1, '사용인감', '')
            .then(async(res: any) => {
              let blob = new Blob([res.data]);
            
            // PNG로 변환
              blob = await convertBlobToPng(blob);
              sealList.사용인감 = blob;
              const url = window.URL.createObjectURL(sealList.사용인감)

              img.value = url
              
              const dimensions = await calculateImageSize(url, 14, offsetScale);
              imgStyle.value = { 
                width: dimensions.width, 
                height: dimensions.height 
              };
            })
            .catch(() => {
              selectedImg.value = ''
            })
        } else {
          const url = window.URL.createObjectURL(sealList.사용인감)
          img.value = url
          const dimensions = await calculateImageSize(url, 18, offsetScale);
          imgStyle.value = { 
            width: dimensions.width, 
            height: dimensions.height 
          };
        }
      }
      break
    case '원본대조필':
      {
        if (sealList.원본대조필 == '') {
          userApi
            .sealFile(1, '원본대조필', '')
            .then(async(res: any) => {
              let blob = new Blob([res.data]);
            
            // PNG로 변환
              blob = await convertBlobToPng(blob);
              sealList.원본대조필 = blob;
              const url = window.URL.createObjectURL(sealList.원본대조필)
              img.value = url
              imgStyle.value = { width: mmToPx(50) * offsetScale, height: mmToPx(10) * offsetScale }
            })
            .catch(() => {
              selectedImg.value = ''
            })
        } else {
          const url = window.URL.createObjectURL(sealList.원본대조필)
          img.value = url
          imgStyle.value = { width: mmToPx(50) * offsetScale, height: mmToPx(10) * offsetScale }
        }
      }
      break
    case '인감':{
      if (sealList.인감 != '') {
          const url = window.URL.createObjectURL(sealList.인감)
          img.value = url
          imgStyle.value = { width: mmToPx(18) * offsetScale, height: mmToPx(18) * offsetScale }
        }else {
          passwordFlag.value = true
        } 
      }
      break
  }
}
const passwordChk = (password: string) => {
  userApi
    .sealFile(1, '인감', password)
    .then(async(res: any) => {
      let blob = new Blob([res.data]);
    
      // PNG로 변환
      blob = await convertBlobToPng(blob);
      sealList.인감 = blob;
      const url = window.URL.createObjectURL(sealList.인감)
      img.value = url
      imgStyle.value = { width: mmToPx(18) * offsetScale, height: mmToPx(18) * offsetScale }
      passwordFlag.value = false
    })
    .catch((err) => {
      console.log(err)
      selectedImg.value = ''
    })
}
let ImageList: Signature[] = []
const addImage = async (e: any) => {
  const textLayer = e.target.closest('.textLayer')
  if (selectedImg.value == '') return
  if (!textLayer) {
    return
  }
  const pageElement = e.target.closest('.page')
  const pageNumber = pageElement.dataset.pageNumber
  const targetWidth = e.target.offsetWidth
  const targetHeight = textLayer.offsetHeight
  const boundingRect = textLayer.getBoundingClientRect()
  const x = e.clientX - boundingRect.left
  const y = e.clientY - boundingRect.top
  const existingPdf = await fetch(pdfSrc.value).then((res) => res.arrayBuffer())
  const pdfDoc = await PDFDocument.load(existingPdf)
  let makBytes: ArrayBuffer | undefined,
    wonBytes: ArrayBuffer | undefined,
    ingBytes: ArrayBuffer | undefined
  if (sealList.사용인감 != '') {
    makBytes = await sealList.사용인감.arrayBuffer()
  }
  if (sealList.원본대조필 != '') {
    wonBytes = await sealList.원본대조필.arrayBuffer()
  }
  if (sealList.인감 != '') {
    ingBytes = await sealList.인감.arrayBuffer()
  }
  let makImage: PDFImage | undefined, wonImage: PDFImage | undefined, ingImage: PDFImage | undefined
  if (makBytes) {
    makImage = await pdfDoc.embedPng(makBytes)
  }
  if (wonBytes) {
    wonImage = await pdfDoc.embedPng(wonBytes)
  }
  if (ingBytes) {
    ingImage = await pdfDoc.embedPng(ingBytes)
  }
  let image: PDFImage | undefined
  switch (selectedImg.value) {
    case '사용인감':
      image = makImage
      break
    case '원본대조필':
      image = wonImage
      break
    case '인감도장':
      image = ingImage
      break
  }
  const page = pdfDoc.getPages()[pageNumber - 1]
  const { width, height } = page.getSize()
  const newX = x * (width / targetWidth) - (imgStyle.value.width / 2) * (width / targetWidth)
  const newY =
    targetHeight * (height / targetHeight) -
    y * (height / targetHeight) -
    (imgStyle.value.height / 2) * (width / targetWidth)
  const imgCnt = ImageList.length
  if (
    !ImageList.some(
      (item) =>
        item.page === pageNumber - 1 &&
        Math.abs(item.x - newX) <= 50 * (width / targetWidth) &&
        Math.abs(item.y - newY) <= 50 * (width / targetWidth)
    )
  ) {
    if (allpageseal.value) {
      for (let i = 0; i < imgFile.value.length; i++) {
        ImageList.push({
          page: i,
          x: newX,
          y: newY,
          scale: width / targetWidth,
          type: selectedImg.value,
          size: JSON.parse(JSON.stringify(imgStyle.value))
        })
      }
    } else {
      ImageList.push({
        page: pageNumber - 1,
        x: newX,
        y: newY,
        scale: width / targetWidth,
        type: selectedImg.value,
        size: JSON.parse(JSON.stringify(imgStyle.value))
      })
    }
  }
  if (imgCnt != ImageList.length) {
    drawSign()
  }
}
const removeImage = async (e: any) => {
  const textLayer = e.target.closest('.textLayer')
  if (!textLayer) {
    return
  }
  const pageElement = e.target.closest('.page')
  const pageNumber = pageElement.dataset.pageNumber
  const targetWidth = e.target.offsetWidth
  const targetHeight = e.target.offsetHeight
  const boundingRect = e.target.getBoundingClientRect()
  const x = e.clientX - boundingRect.left
  const y = e.clientY - boundingRect.top

  const existingPdf = await fetch(pdfSrc.value).then((res) => res.arrayBuffer())
  const pdfDoc = await PDFDocument.load(existingPdf)
  const page = pdfDoc.getPages()[pageNumber - 1]
  const { width, height } = page.getSize()
  const imgCnt = ImageList.length
  for (let i = 0; i < ImageList.length; i++) {
    const scaledX = x * (width / targetWidth) - (ImageList[i].size.width/2 * ImageList[i].scale)
    const scaledY =
      targetHeight * (height / targetHeight) -
      y * (height / targetHeight) -
      ImageList[i].size.height/2 * ImageList[i].scale
    if (
      ImageList[i].page === pageNumber - 1 &&
      Math.abs(ImageList[i].x - scaledX) <= ImageList[i].size.width/2 * ImageList[i].scale &&
      Math.abs(ImageList[i].y - scaledY) <= ImageList[i].size.height/2 * ImageList[i].scale
    ) {
      ImageList.splice(i, 1)
    }
  }
  if (imgCnt != ImageList.length) {
    drawSign()
  }
}
const handleScroll = (e: any) => {
  console.log(e)
}
const drawSign = async () => {
  const existingPdf = await fetch(oriPdfSrc.value).then((res) => res.arrayBuffer())
  const pdfDoc = await PDFDocument.load(existingPdf)
  const form = pdfDoc.getForm();
  form.flatten();

  let makBytes: ArrayBuffer | undefined,
    wonBytes: ArrayBuffer | undefined,
    ingBytes: ArrayBuffer | undefined
  if (sealList.사용인감 != '') {
    makBytes = await sealList.사용인감.arrayBuffer()
  }
  if (sealList.원본대조필 != '') {
    wonBytes = await sealList.원본대조필.arrayBuffer()
  }
  if (sealList.인감 != '') {
    ingBytes = await sealList.인감.arrayBuffer()
  }
  let makImage: PDFImage | undefined, wonImage: PDFImage | undefined, ingImage: PDFImage | undefined
  if (makBytes) {
    makImage = await pdfDoc.embedPng(makBytes)
  }
  if (wonBytes) {
    wonImage = await pdfDoc.embedPng(wonBytes)
  }
  if (ingBytes) {
    ingImage = await pdfDoc.embedPng(ingBytes)
  }
  ImageList.forEach((dto: Signature) => {
    let image: PDFImage | undefined
    switch (dto.type) {
      case '사용인감':
        image = makImage
        break
      case '원본대조필':
        image = wonImage
        break
      case '인감':
        image = ingImage
        break
    }
    if (image) {
      const page = pdfDoc.getPages()[dto.page]
      page.drawImage(image, {
        x: dto.x,
        y: dto.y,
        width: dto.size.width * dto.scale,
        height: dto.size.height * dto.scale
      })
    }
  })
  const pdfBytes = await pdfDoc.save()
  const blob = new Blob([pdfBytes], { type: 'application/pdf' })
  pdfSrc.value = URL.createObjectURL(blob)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "cover" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[7] || (_cache[7] = _createTextVNode("계 약 서 ")),
        _createElementVNode("img", {
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
          class: "close_icon"
        })
      ]),
      (_ctx.type != 'R')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              style: _normalizeStyle([{"width":"100px","height":"30px","margin":"5px","text-align":"center","line-height":"30px","color":"#fff","border-radius":"8px","cursor":"pointer"}, {background:selectedImg.value == '사용인감' ? '#3382E9' : '#919191'}]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (ImgChange('사용인감')))
            }, " 사용인감 ", 4),
            _createElementVNode("div", {
              style: _normalizeStyle([{"width":"100px","height":"30px","margin":"5px","text-align":"center","line-height":"30px","color":"#fff","border-radius":"8px","cursor":"pointer"}, {background:selectedImg.value == '원본대조필' ? '#3382E9' : '#919191'}]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (ImgChange('원본대조필')))
            }, " 원본대조필 ", 4),
            _createElementVNode("div", {
              style: _normalizeStyle([{"width":"100px","height":"30px","margin":"5px","text-align":"center","line-height":"30px","color":"#fff","border-radius":"8px","cursor":"pointer"}, {background:selectedImg.value == '인감' ? '#3382E9' : '#919191'}]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (ImgChange('인감')))
            }, " 인감 ", 4),
            _createElementVNode("div", {
              style: {"width":"100px","height":"30px","margin":"5px","margin-left":"auto","text-align":"center","line-height":"30px","color":"#fff","border":"1px solid #041e42","border-radius":"8px","cursor":"pointer","background":"#383838"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (newSrc.value!.click()))
            }, " 계약서업로드 ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        ref_key: "pdfContainer",
        ref: pdfContainer,
        style: {"height":"calc(100% - 100px)"},
        class: "pdfContainer"
      }, [
        _createVNode(_unref(VuePdfApp), {
          class: "vue-pdf",
          style: {"height":"100%","width":"100%","position":"relative"},
          pdf: pdfSrc.value,
          onClick: _withModifiers(addImage, ["left"]),
          onContextmenu: _withModifiers(removeImage, ["right"]),
          onScroll: handleScroll,
          onPagesRendered: pagesRenderedHandler,
          onAfterCreated: afterCreatedHandler,
          oncontextmenu: "return false",
          config: {
          toolbar: false}
        }, null, 8, ["pdf"])
      ], 512),
      (_ctx.type != 'R')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "sealComplete",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((sealChecked).value = $event)),
                style: {"display":"inline-block"}
              }, null, 512), [
                [_vModelCheckbox, sealChecked.value]
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("label", { for: "sealComplete" }, "날인완료", -1))
            ]),
            _createElementVNode("div", {
              style: {"width":"300px","height":"50px","border-radius":"8px","text-align":"center","line-height":"50px","margin":"0 auto"},
              class: "contract_btn",
              onClick: confirm
            }, " 작성 완료 ")
          ]))
        : _createCommentVNode("", true),
      (selectedImg.value != '')
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            class: "cursor disabled",
            src: img.value,
            style: _normalizeStyle({ width: imgStyle.value.width + 'px', height: imgStyle.value.height + 'px' })
          }, null, 12, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        type: "file",
        ref_key: "newSrc",
        ref: newSrc,
        onChange: openSrc,
        style: {"display":"none"}
      }, null, 544)
    ]),
    (passwordFlag.value)
      ? (_openBlock(), _createBlock(PasswordPop, {
          key: 0,
          onPasswordChk: passwordChk,
          onClosePop: _cache[6] || (_cache[6] = ($event: any) => {passwordFlag.value = false;selectedImg.value=''})
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})